module.exports = __webpack_public_path__ + "static/img/12-2.35163f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12-2.jpg
// module id = wJy4
// module chunks = 0